import { IContacts } from '@interfaces/contacts/IContacts'
import { IListPaginated } from '@interfaces/api/IRequestsReturn'
import api from '@services/api/server'
import { IMessage } from '@interfaces/iMessage'

export default class ContactsService {
    public static async list(page: number, perPage = 25, search?: string): Promise<IListPaginated<IContacts>> {
        if (search === '') {
            search = undefined
        }
        return (
            await api.get<IListPaginated<IContacts>>('/contact-form', {
                params: {
                    page,
                    perPage,
                    search,
                },
            })
        ).data
    }

    public static async delete(id: number): Promise<IMessage> {
        return (await api.delete<IMessage>(`/contact-form/${id}`)).data
    }

    public static async getFileKey(id: number): Promise<string> {
        return (await api.get<string>(`/contact-form/${id}/resume`)).data
    }

    public static async visualize(id: number): Promise<IContacts> {
        return (await api.patch<IContacts>(`/contact-form/${id}`)).data
    }
}
